export const getBaseName = (returnDefault = true) => {
  if (!process.env.PUBLIC_URL && returnDefault)
    return "/";
  
  return process.env.PUBLIC_URL;
}

export const redirectToBase = () => {
  window.location.href = "/";
}